export type UspType = "trust" | "ambition" | "adaptability" | "enjoyment";

export interface UspContent {
  type: UspType;
  title: string;
  description: string;
}

export const USP_VALUES: UspContent[] = [
  {
    type: "trust",
    title: "Flexibility",
    description: "Flexibility is our super power. We’re fully capable to adapt any change or need."
  },
  {
    type: "ambition",
    title: "Synergy",
    description: "The Soloop synergy is built on trust, teamwork and a shared sense of purpose."
  },
  {
    type: "adaptability",
    title: "Quality",
    description: "We have built a lot and know what’s good. It is what we guarantee."
  },
  {
    type: "enjoyment",
    title: "Reliability",
    description: "We do not consider reliability a promise. To us it’s rather practice. Daily."
  }
]; 